import * as React from "react";
import { app } from "@microsoft/teams-js";
import { RouteComponentProps } from 'react-router-dom';
import { Button, Flex, Image, Label, Segment, Text } from "@fluentui/react-northstar";
import { InfoIcon } from '@fluentui/react-icons-northstar';
import { initializeIcons } from '@fluentui/react';
import {
    getAppConfig,
    getMeetingData,
    getMeetingQueueData,
    getAppSettings,
    rating,
    updateAssuntoQueue,
    startCall,
    inactivateQueue,
    updateQueueExternalUser,
    cancelQueue
} from '../../api/publicapp-api';
import QueueWelcomeCard from "./queue-cards/bem-vindo";
import QueueNaFilaCard from "./queue-cards/na-fila";
import QueueStartedCard from "./queue-cards/atendimento-iniciado";
import QueueEndedCard from "./queue-cards/atendimento-encerrado";
import QueueInactivedCard from "./queue-cards/atendimento-inativo";
import QueueScheduledCard from "./queue-cards/atendimento-agendado";
import QueueCancelledCard from "./queue-cards/atendimento-cancelado";
import RedirectUrlsConstants from '../../constants/redirect-urls';
import StatusQueueConstants from "../../constants/status-queue";
import ConstantsSoundBeep from '../../constants/sound-beep';
import VLibras from "@djpfs/react-vlibras";
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { Routes } from "../../constants";
import { updateLocale } from "../../i18n";
import "./meeting-queue.scss";

interface IState {
    appConfigs: any;
    appSettings: any;
    ancora: string;
    botWriting: boolean;
    botWriting1: boolean;
    step: number;
    meetingData: any;
    meetingQueueData: any;
    queues: any;
    keepAliveInterval: any;
    inactive: boolean;
    rate: number;
    rateLabel: string;
    comments: string;
    ratingSent: boolean;
    callInProgress: boolean;
    assuntoSelected?: any;
    ratingQuestions?: any;
    scheduled: boolean;
    acsEnabled: boolean,
    mounted: boolean,
}

export type MeetingQueueProps = {} & RouteComponentProps & WithTranslation;

class MeetingQueue extends React.Component<MeetingQueueProps, IState> {
    queueId?: any = null;
    assuntoParam?: any = null;
    scheduleParam?: any = null;
    appName?: any = null;
    audio?: any = null;
    audioElement?: any = null;
    search?: any = null;
    dataParameter?: any = null;
    localize: TFunction;
    teamsContext: boolean;

    constructor(props: MeetingQueueProps) {
        super(props);

        initializeIcons();
        this.localize = this.props.t;
        this.audioElement = React.createRef();

        const hasAncestorOrigins = 'ancestorOrigins' in window.location;

        if (hasAncestorOrigins) {
            this.teamsContext = window.location.ancestorOrigins[0] &&
                window.location.ancestorOrigins[0].toLowerCase().includes("teams");
        } else {
            this.teamsContext = false;
        }

        let pathname = window.location.pathname;

        this.state = {
            appConfigs: null,
            appSettings: null,
            ancora: pathname.split("/")[2],
            botWriting: true,
            botWriting1: false,
            step: 0,
            meetingData: [],
            meetingQueueData: [],
            queues: [],
            keepAliveInterval: null,
            inactive: false,
            rate: 0,
            rateLabel: "",
            comments: "",
            ratingSent: false,
            callInProgress: false,
            assuntoSelected: null,
            ratingQuestions: null,
            scheduled: false,
            acsEnabled: false,
            mounted: false,
        }

        this.search = new URLSearchParams(window.location.search);
        this.dataParameter = this.search.get("data");

        let data = this.dataParameter ? window.atob(this.dataParameter) : "";
        let dataValue = JSON.parse(data);

        this.queueId = dataValue['queueId'] ?? "";
        this.assuntoParam = decodeURIComponent(dataValue['assunto']) ?? null;
        this.scheduleParam = dataValue['schedule'] ?? null;
        this.appName = dataValue['appName'] ?? null;

        if (this.queueId == "") {
            window.location.pathname = `/errorpage?msg=QueueId is invalid`;
        }
    }


    /**
    * Used to initialize this component.
    */
    public componentDidMount = async () => {
        setTimeout(() => this.setState({ botWriting: false }), 2500);

        if (this.teamsContext) {
            app.initialize();
            app.getContext().then(async (context: app.Context) => {
                await updateQueueExternalUser(this.queueId,
                    {
                        userName: context.user.displayName,
                        userLogin: context.user.userPrincipalName,
                        userAadObjectId: context.user.id,
                        tenantId: context.user.tenant.id,
                        email: context.user.loginHint,
                    }
                );
            });
            window.localStorage.setItem("queueData", this.dataParameter);
        }

        if (this.appName) {
            window.document.title = decodeURIComponent(this.appName);
        }

        await this.getAppConfig();
        await this.getAppSettings();
        await this.getMeetingData();
        await this.getMeetingQueueData();
    }

    /**
     * Get App Configs
     * */
    private getAppConfig = async () => {
        let response = await getAppConfig();
        if (response.status === 200 && response.data) {

            if (response.data?.queueRingSound?.toLowerCase() == "queuesoundtelephone") {
                this.audio = ConstantsSoundBeep.queueSoundTelephone;
            }
            else {
                this.audio = ConstantsSoundBeep.queueSoundDefault;
            }

            this.setState({
                appConfigs: response.data,
                ratingQuestions: response.data?.ratingQuestions ? JSON.parse(response.data.ratingQuestions) : null
            });
        }
    };

    /**
     * Get App Settings
     * */
    private getAppSettings = async () => {
        let response = await getAppSettings();
        if (response.status === 200 && response.data) {
            this.setState({
                appSettings: response.data,
            });

            if (response.data.language)
                updateLocale(response.data.language);
        }
    };

    /**
    * Get meeting data.
    */
    public getMeetingData = async () => {
        let response = await getMeetingData(this.state.ancora);

        if (response.status === 200 && response.data) {
            this.setState({
                meetingData: response.data,
                acsEnabled: response.data.acsEnabled,
            });

            var matchAssunto = response.data.assuntos?.filter((v: string) => this.assuntoParam.toLowerCase() === v.toLowerCase());

            if (matchAssunto?.length) {
                this.setState({
                    assuntoSelected: matchAssunto,
                })
            }
        }
    }

    /**
    * Get meeting queue data.
    */
    public getMeetingQueueData = async () => {
        const response = await getMeetingQueueData(this.state.ancora, this.queueId, this.scheduleParam);

        if (!response.data) {
            window.location.href = `${Routes.publicApp.avisoIndisponivel}/${this.state.ancora}`;
        }

        if (response.status === 200 && response.data) {
            this.setState({
                meetingQueueData: response.data,
                mounted: true,
            }, () => {
                if (this.state.assuntoSelected) {
                    updateAssuntoQueue(this.state.ancora, response.data.id, this.state.assuntoSelected)
                }

                if (response.data.status === StatusQueueConstants.atendimentoAgendado ||
                    response.data.history.find((e: any) => e.status === StatusQueueConstants.atendimentoAgendado)) {
                    this.setState({
                        scheduled: true,
                    })
                }

                if (response.data.status === StatusQueueConstants.emAtendimento) {
                    this.setState({
                        callInProgress: true,
                    })

                    this.keepAlive();
                }

                if (response.data.status === StatusQueueConstants.naFila ||
                    (response.data.status === StatusQueueConstants.atendimentoAgendado && response.data.scheduleDay) ||
                    response.data.status === StatusQueueConstants.atendimentoIniciado) {
                    this.keepAlive();
                }
            });
        }
    }

    /**
    * Keep alive queues.
    */
    public keepAlive = async () => {
        let keepAlive = setInterval(() => {
            getMeetingQueueData(this.state.ancora, this.state.meetingQueueData.id).then((result: any) => {
                this.setState({
                    meetingQueueData: {
                        ...this.state.meetingQueueData,
                        queues: result.data.queues,
                        queuePosition: result.data.queuePosition,
                        status: result.data.status,
                        meetingUrl: result.data.meetingUrl,
                        meetingSubject: result.data.meetingSubject,
                        assuntoSelected: result.data.assuntos,
                        availableMeeting: result.data.availableMeeting,
                    },
                    mounted: false,
                });

                if (result.data.status == StatusQueueConstants.atendimentoIniciado && !!result.data.availableMeeting) {
                    this.alertBeep(true);
                }

                if (result.data.status == StatusQueueConstants.emAtendimento) {
                    this.alertBeep(false);
                    this.setState({ callInProgress: true })
                }

                if (result.data.status == StatusQueueConstants.atendimentoEncerrado ||
                    result.data.status == StatusQueueConstants.atendimentoInativo ||
                    this.state.inactive) {
                    const element = document.querySelector<HTMLElement>("body")!;

                    element.removeAttribute("style");

                    clearInterval(this.state.keepAliveInterval);
                }
            })
        }, 20000);

        this.setState({
            keepAliveInterval: keepAlive,
        })
    }

    /**
    * Start call.
    */
    public startCall = () => {
        this.alertBeep(false);

        let meetingUrl = this.state.meetingQueueData.meetingUrl;

        if (!this.state.callInProgress) {
            if (this.state.acsEnabled) {
                startCall(this.state.meetingQueueData.id, this.state.ancora).then(() => {
                    this.setState({ callInProgress: true })
                });
            } else {
                startCall(this.state.meetingQueueData.id, this.state.ancora).then(() => {
                    this.setState({ callInProgress: true })

                    if (this.teamsContext) {
                        const url = window.location.ancestorOrigins[0].includes("cloud") ?
                            meetingUrl.replace("https://teams.microsoft.com", "https://teams.cloud.microsoft") :
                            meetingUrl;

                        app.openLink(url);
                    } else {
                        if (this.state.appConfigs.useTeamsAppForJoin) {
                            meetingUrl = meetingUrl.replace(RedirectUrlsConstants.browserForJoin, RedirectUrlsConstants.teamsAppForJoin);
                            window.open(meetingUrl);
                        }
                        else {
                            window.open(meetingUrl);
                        }
                    }
                });
            }
        } else {
            if (this.teamsContext) {
                const url = window.location.ancestorOrigins[0].includes("cloud") ?
                    meetingUrl.replace("https://teams.microsoft.com", "https://teams.cloud.microsoft") :
                    meetingUrl;

                app.openLink(url);
            } else {
                if (this.state.appConfigs.useTeamsAppForJoin) {
                    meetingUrl = meetingUrl.replace(RedirectUrlsConstants.browserForJoin, RedirectUrlsConstants.teamsAppForJoin);
                    window.open(meetingUrl);
                }
                else {
                    window.open(meetingUrl);
                }
            }
        }
    }

    /**
    * Join chat.
    */
    public joinChat = () => {
        this.alertBeep(false);

        let meetingUrl = this.state.meetingQueueData.meetingUrl;

        if (!this.state.callInProgress) {
            if (this.state.acsEnabled) {
                startCall(this.state.meetingQueueData.id, this.state.ancora).then(() => {
                    this.setState({ callInProgress: true })
                });
            } else {
                startCall(this.state.meetingQueueData.id, this.state.ancora).then(() => {
                    this.setState({ callInProgress: true })

                    const regex = /\/meetup-join\/([^\/?]+)/;
                    const match = meetingUrl.match(regex);
                    const chatId = match[1];

                    const url = window.location.ancestorOrigins[0].includes("cloud") ?
                        `https://teams.cloud.microsoft/l/chat/${chatId}` : `https://teams.microsoft.com/l/chat/${chatId}`;

                    app.openLink(url);
                });
            }
        } else {
            const regex = /\/meetup-join\/([^\/?]+)/;
            const match = meetingUrl.match(regex);
            const chatId = match[1];

            const url = window.location.ancestorOrigins[0].includes("cloud") ?
                `https://teams.cloud.microsoft/l/chat/${chatId}` : `https://teams.microsoft.com/l/chat/${chatId}`;

            app.openLink(url);
        }
    }

    /**
    * Queue wait time.
    */
    public timerTimeout = async () => {
        if (!this.state.callInProgress) {
            inactivateQueue(this.state.meetingQueueData.id, this.state.ancora).then((response: any) => {
                this.setState({ inactive: true })
                this.alertBeep(false);
                clearInterval(this.state.keepAliveInterval);
            })
        }
    }

    /**
    * Queue wait time.
    */
    public cancelQueue = async () => {
       await cancelQueue(this.state.meetingQueueData.id).then(async (response: any) => {
            this.alertBeep(false);
            clearInterval(this.state.keepAliveInterval);

            await this.getMeetingQueueData();
        });
    }

    /**
    * Alert beep.
    */
    public alertBeep = (play: boolean) => {
        if (play) {
            this.audioElement.current.currentTime! = 0;
            this.audioElement.current!.muted = false;
        } else {
            if (this.audioElement.current) {
                this.audioElement.current!.muted = true;
                this.audioElement.current?.pause();
            }
        }
    }

    /**
    * Rating.
    */
    public setRating = (rate: number) => {
        this.setState({
            rate: rate
        })

        if (rate == 1) {
            this.setState({ rateLabel: this.localize("Ruim") })
        } else if (rate == 2) {
            this.setState({ rateLabel: this.localize("Regular") })
        } else if (rate == 3) {
            this.setState({ rateLabel: this.localize("Bom") })
        } else if (rate == 4) {
            this.setState({ rateLabel: this.localize("Ótimo") })
        } else if (rate == 5) {
            this.setState({ rateLabel: this.localize("Excelente") })
        }
    }

    /**
    * Send rate.
    */
    public sendRating = () => {
        var objRating = {
            Rate: this.state.rate,
            Comments: this.state.comments
        };

        rating(this.state.meetingQueueData.id, this.state.ancora, objRating).then((response: any) => {
            this.setState({ ratingSent: true })
        })
    }

    /**
    * Send custom rating.
    */
    public sendCustomRating = () => {
        rating(this.state.meetingQueueData.id, this.state.ancora, JSON.stringify(this.state.ratingQuestions)).then((response: any) => {
            this.setState({ ratingSent: true })
        })
    }

    /**
     * Parse week days with locale
     * */
    public daysOfWeekLocale = (day: string) => {
        if (day)
            return day
                .replace(/segunda-feira/, this.localize('SegundaFeira'))
                .replace(/terça-feira/, this.localize('TercaFeira'))
                .replace(/quarta-feira/, this.localize('QuartaFeira'))
                .replace(/quinta-feira/, this.localize('QuintaFeira'))
                .replace(/sexta-feira/, this.localize('SextaFeira'))
                .replace(/sábado/, this.localize('Sabado'))
                .replace(/domingo/, this.localize('Domingo'))
    }

    /**
    * Render header.
    */
    public renderHeader = () => {
        return (
            this.state.appConfigs ?
                <Flex>
                    <audio muted autoPlay loop id="alertBeep" ref={this.audioElement} hidden={true} controls>
                        <source src={this.audio} type="audio/wav" />
                    </audio>
                    <Flex.Item>
                        <Flex className="logo" gap="gap.small" vAlign="center">
                            <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                            <Text weight="semibold" content={this.appName !== null ? decodeURIComponent(this.appName) : this.localize("BalcaoVirtual")} size="medium" />
                        </Flex>
                    </Flex.Item>
                    <Flex.Item grow>
                        <Flex hAlign="center" vAlign="center">
                            <Label className="headerLabel" content={this.state.appConfigs.tribunal} />
                        </Flex>
                    </Flex.Item>
                    <Flex.Item push>
                        <Flex gap="gap.smaller" vAlign="center" className="sobre" onClick={() => window.open("https://balcaovirtual.studio365.io/", "_blank") }>
                            <InfoIcon outline />
                            <Text weight="light" content={this.localize("Sobre")} size="small" />
                        </Flex>
                    </Flex.Item>
                </Flex>
                :
                <React.Fragment />
        )
    }

    /**
    * Render Assuntos.
    */
    public renderAssuntos = (item: any, index: number) => {
        return (
            <Button key={index} content={item} primary onClick={() => {
                updateAssuntoQueue(this.state.ancora, this.state.meetingQueueData.id, item).then((response: any) => {
                    this.setState({
                        assuntoSelected: item
                    })
                })
            }} />
        )
    }

    /**
    * Rating question changed.
    */
    private onQuestionChanged = (event: any) => {
        var indexSession = event.currentTarget.className.split('-')[0];
        var questionId = event.currentTarget.className.split('-')[1];
        var indexQuestion = this.state.ratingQuestions.data.sessions[indexSession].questions.findIndex((obj: any) => obj.id === questionId);

        this.state.ratingQuestions.data.sessions[indexSession].questions[indexQuestion].selectedValue = event.currentTarget.id;
        this.state.ratingQuestions.data.sessions[indexSession].questions[indexQuestion].selectedText = event.currentTarget.value;

        this.setState({
            ratingQuestions: this.state.ratingQuestions
        })
    }

    private onCommentChange = (event: any) => {
        this.setState({
            comments: event.target.value,
        });
    }

    /**
    * Render body.
    */
    public renderWelcomeCard = () => {
        return (
            <React.Fragment>
                {(this.state.meetingQueueData.status != StatusQueueConstants.atendimentoEncerrado &&
                    !this.state.inactive)
                    &&
                    <QueueWelcomeCard
                        botWriting={this.state.botWriting}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        meetingData={this.state.meetingData}
                        meetingQueueData={this.state.meetingQueueData}
                        daysOfWeekLocale={this.daysOfWeekLocale}
                    />
                }

                {!this.state.botWriting &&
                    this.renderCards()
                }

            </React.Fragment>
        )
    }

    /**
     * Render queue cards.
     * */
    public renderCards = () => {
        return (
            <React.Fragment>
                {(this.state.meetingQueueData.queuePosition > 0 &&
                    !this.state.inactive &&
                    !this.state.meetingQueueData.availableMeeting &&
                    this.state.meetingQueueData.status != StatusQueueConstants.atendimentoAgendado) &&
                    <QueueNaFilaCard
                        botWriting1={this.state.botWriting1}
                        appConfigs={this.state.appConfigs}
                        meetingData={this.state.meetingData}
                        meetingQueueData={this.state.meetingQueueData}
                        assuntoSelected={this.state.assuntoSelected}
                        renderAssuntos={this.renderAssuntos.bind(this)}
                        teamsContext={this.teamsContext}
                        cancelQueue={this.cancelQueue}
                    />
                }

                {((this.state.meetingQueueData.status == StatusQueueConstants.atendimentoIniciado || this.state.meetingQueueData.status == StatusQueueConstants.emAtendimento)
                    && !this.state.inactive) &&
                    <QueueStartedCard
                        botWriting1={this.state.botWriting1}
                        ancora={this.state.ancora}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        meetingData={this.state.meetingData}
                        meetingQueueData={this.state.meetingQueueData}
                        startCall={this.startCall}
                        joinChat={this.joinChat}
                        callInProgress={this.state.callInProgress}
                        timerTimeout={this.timerTimeout}
                        scheduled={this.state.scheduled}
                        acsEnabled={this.state.acsEnabled}
                        teamsContext={this.teamsContext}
                        availableMeeting={this.state.meetingQueueData.availableMeeting}
                    />
                }

                {(this.state.meetingQueueData.status == StatusQueueConstants.atendimentoEncerrado) &&
                    <QueueEndedCard
                        botWriting1={this.state.botWriting1}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        meetingData={this.state.meetingData}
                        meetingQueueData={this.state.meetingQueueData}
                        ratingSent={this.state.ratingSent}
                        rate={this.state.rate}
                        rateLabel={this.state.rateLabel}
                        setRating={this.setRating}
                        sendRating={this.sendRating}
                        ratingQuestions={this.state.ratingQuestions}
                        onCommentChange={this.onCommentChange}
                        onQuestionChanged={this.onQuestionChanged}
                        sendCustomRating={this.sendCustomRating}
                        mounted={this.state.mounted}
                    />
                }

                {(this.state.meetingQueueData.status == StatusQueueConstants.atendimentoAgendado) &&
                    <QueueScheduledCard
                        botWriting={this.state.botWriting}
                        ancora={this.state.ancora}
                        meetingData={this.state.meetingData}
                        meetingQueueData={this.state.meetingQueueData}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        daysOfWeekLocale={this.daysOfWeekLocale}
                    />
                }

                {(this.state.meetingQueueData.status == StatusQueueConstants.atendimentoInativo ||
                    this.state.inactive) &&
                    <QueueInactivedCard
                        botWriting1={this.state.botWriting1}
                        ancora={this.state.ancora}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        meetingQueueData={this.state.meetingQueueData}
                    />
                }

                {(this.state.meetingQueueData.status == StatusQueueConstants.atendimentoCancelado) &&
                    <QueueCancelledCard
                        botWriting1={this.state.botWriting1}
                        ancora={this.state.ancora}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        meetingQueueData={this.state.meetingQueueData}
                    />
                }
            </React.Fragment>
        )
    }

    /**
     * Render this component.
     * */
    public render(): JSX.Element {
        return (
            <div className="meeting-queue">
                <div>
                    <VLibras forceOnload={true} />
                </div>
                <div className="header">
                    <Segment
                        className="headerLine"
                        inverted
                        content={this.renderHeader()}
                    />
                </div>
                <div className="body">
                    {this.renderWelcomeCard()}
                </div>
            </div>
        );
    }
}

const meetingQueueWithTranslation = withTranslation()(MeetingQueue);
export default meetingQueueWithTranslation;